import {createContext } from "react";


const SalePointTypeContext = createContext();

export default SalePointTypeContext;